import React, { useEffect, useState } from "react";
import styles from "../Dashoard.module.css";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import ListingCard from "../../ListingCard/ListingCard";
import ScrollBar from "../../ScrollBar/ScrollBar";
import EmptyCard from "../../EmptyCard/EmptyCard";
import { InfoIcon } from "../../../assets/icons/InfoIcon";

const Calendar = (props) => {
  const { sessionsUpcoming } = props;

  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    let newCardData = [];
    if (sessionsUpcoming?.length > 0) {
      sessionsUpcoming.sort(
        (a, b) => new Date(a.startTime) - new Date(b.startTime)
      );
      sessionsUpcoming?.map((singleUpcomingSession, index) => {
        let timeInfo = formatSessionTime(
          singleUpcomingSession.startTime,
          singleUpcomingSession.startTime,
          singleUpcomingSession.endTime
        );

        newCardData.push({
          SelectedBackground: index == 0 && "#EBF2FF",
          title: singleUpcomingSession?.title,
          Date: timeInfo?.startDate,
          Time: `${timeInfo?.timeRange} (${timeInfo?.timeZoneAbbr})`,
          chipLabel: "Pending",
          color: "#004FE0",
          //onClick:onClick,
        });
      });
      setCardData(newCardData);
    }
  }, [sessionsUpcoming]);

  function formatSessionTime(startDate, startTime, endTime) {
    // Define the time zone for Eastern Time (EST/EDT)
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const dateString = startDate;
    const date = new Date(dateString);

    // Format the date to 'Wed, Mar 1, 2024'
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "short", // Abbreviated day of the week (e.g., "Wed")
      month: "short", // Abbreviated month (e.g., "Mar")
      day: "numeric", // Day of the month (e.g., "1")
      year: "numeric", // Full year (e.g., "2024")
      timeZone: timeZone,
    });

    // Create Date objects from the provided ISO timestamps
    const startDateTime = new Date(startTime);
    const endDateTime = new Date(endTime);

    // Define formatting options
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // AM/PM format
      timeZone: timeZone,
    };

    // Format the start and end times
    const formattedStart = new Intl.DateTimeFormat("en-US", options).format(
      startDateTime
    );
    const formattedEnd = new Intl.DateTimeFormat("en-US", options).format(
      endDateTime
    );

    // Get the timezone abbreviation (e.g., "EST")
    const timeZoneAbbr = startDateTime
      .toLocaleString("en-US", { timeZoneName: "short", timeZone })
      .split(" ")
      .pop();

    // Return the formatted time range string
    return {
      startDate: formattedDate,
      timeRange: `${formattedStart} - ${formattedEnd}`,
      timeZoneAbbr: `${timeZoneAbbr}`,
    };
  }

  return (
    <div className={styles.CardSection}>
      <div className={styles.CardSectionTitle}>
        Calendar
        {/* <Button className={styles.SeaAllButton} variant="text">See all</Button> */}
      </div>

      {sessionsUpcoming?.length > 0 && (
        <ScrollBar
          height="300px"
          BottomSpace="0"
          body={
            <Grid container spacing={1}>
              {cardData.map((item, i) => (
                <Grid item xs={12} sm={12}>
                  <ListingCard
                    LineStatus={true}
                    Title={item.title}
                    Description={item.description}
                    StatusColor={item.color}
                    ChipLabel={item.chipLabel}
                    SelectedBackground={item.SelectedBackground}
                    DateTitmeStatus={true}
                    Date={item.Date}
                    Time={item.Time}
                    onClick={item.onClick}
                  />
                </Grid>
              ))}
            </Grid>
          }
        />
      )}

      {sessionsUpcoming?.length == 0 && (
        <EmptyCard
          Icon={<InfoIcon />}
          description={
            <div>
              You do not have any courses scheduled <br />
              for this week/month
            </div>
          }
        />
      )}
    </div>
  );
};

export default Calendar;
